import {
  Button,
  styled,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import TableCellComponent from "components/table/TableCellComponent";
import TableRowComponent from "components/table/TableRowComponent";
import { HEADER_CATEGORY_TABLE } from "constants/data";
import { Category } from "../types";

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(even)": {
    backgroundColor: "var(--offwhite-300)",
  },
  "&:nth-of-type(odd)": {
    backgroundColor: "var(--white)",
  },
}));

interface CategoryTableProps {
  categories: Category[];
  openModal: (category: Category) => void;
  total: number;
}

/**
 * CategoryTable component renders a table with category details.
 *
 * @param {CategoryTableProps} props - The properties for the component.
 * @param {Category[]} props.categories - The list of categories to display.
 * @returns {JSX.Element} The rendered table component.
 */
export default function CategoryTable({ categories, openModal, total = 0 }: CategoryTableProps) {
  return (
    <TableContainer
      component={Table}
      sx={{
        minWidth: 1218,
        width: "100%",
        boxShadow: "none",
      }}
    >
      <TableHead>
        <TableRowComponent data={HEADER_CATEGORY_TABLE} type="header" />
      </TableHead>
      <TableBody>
        {categories.map((category, index) => (
          <StyledTableRow key={category.id} className={index % 2 === 0 ? "even" : "odd"}>
            <TableCellComponent>{category.category_cd}</TableCellComponent>
            <TableCellComponent sx={{ textAlign: "left" }}>
              {category.category_kbn_cd}
            </TableCellComponent>

            <TableCellComponent sx={{ textAlign: "left" }}>
              {category.category_kbn}
            </TableCellComponent>

            <TableCellComponent sx={{ textAlign: "left" }}>
              {category.category_name}
            </TableCellComponent>

            <TableCellComponent sx={{ textAlign: "left" }}>{category.seq}</TableCellComponent>

            <TableCellComponent>
              <Button
                variant="outlined"
                onClick={() => {
                  openModal(category);
                }}
                sx={{
                  border: "1px solid var(--gray-250)",
                  backgroundColor: "var(--white)",
                  color: "var(--black)",
                  fontSize: { xs: 16, md: 18, lg: 20 },
                  borderRadius: "4px",
                  width: { xs: "100%", xl: "83%" },
                  height: "40px",
                  whiteSpace: "pre",
                }}
              >
                詳細
              </Button>
            </TableCellComponent>
          </StyledTableRow>
        ))}
      </TableBody>
    </TableContainer>
  );
}
